export async function readJson(response, fallbackMessage = 'İstek başarısız oldu.') {
  const text = await response.text();
  let payload;
  try {
    payload = JSON.parse(text);
  } catch {
    const contentType = response.headers.get('content-type') || 'bilinmiyor';
    throw new Error(`${fallbackMessage} Sunucu JSON yerine ${contentType} döndürdü (HTTP ${response.status}).`);
  }
  if (!response.ok) throw new Error(payload?.message || fallbackMessage);
  return payload;
}

async function request(path) {
  const response = await fetch(path, { headers: { Accept: 'application/json' } });
  return readJson(response);
}

export function searchAnime(query = '') {
  return request(`/api/anime/search?q=${encodeURIComponent(query.trim())}`);
}

export function getAnimeDetail(id) {
  return request(`/api/anime/${encodeURIComponent(id)}`);
}
